import { render, staticRenderFns } from "./DispenserNew.vue?vue&type=template&id=32339d6e"
import script from "./DispenserNew.vue?vue&type=script&lang=js"
export * from "./DispenserNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports